import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
import 'antd/lib/spin/style/css';
import '../../resources/css/Loader.css';
import languages from '../../language/languages';
import { SettingTwoTone } from '@ant-design/icons';
import { Spin } from 'antd';

export const Loading= props  =>
{
    const antIcon = <SettingTwoTone twoToneColor="#fc730a" style={{ fontSize: 24}} spin />;
    const { promiseInProgress } = usePromiseTracker();
    return promiseInProgress &&
        <div className="loading-container">
            <div id="circle">
                <Spin indicator={antIcon} style={{color:"orange"}} tip={languages[props.language].loading}/>
            </div>
        </div>;
};